// extracted by mini-css-extract-plugin
export default {"pi":"get-pi-cities_pi__0zejN"};